import ym from 'react-yandex-metrika';

import { USE_YA } from '../../constants';

export const ecommerce = (deliveryOrders = []) => {
  const hasDeliveryOrders = deliveryOrders && deliveryOrders.length;
  if (USE_YA && hasDeliveryOrders) {
    deliveryOrders.forEach(({ deliveryOrderId, sellerName, amount, deliveryPrice, orders }) => {
      const ecommerce = {
        currencyCode: 'RUB',
        purchase: {
          actionField: {
            id: deliveryOrderId,
            affiliation: sellerName,
            revenue: amount,
            shipping: deliveryPrice,
            tax: 0,
          },
          products: orders.map(({ detailNum, detailName, makeName, price, quantity }, index) => ({
            id: detailNum,
            name: detailName,
            brand: makeName,
            position: index + 1,
            price: price,
            quantity: quantity,
          }))
        }
      };

      window.dataLayer.push({ ecommerce });
    }
    )
  }

  if (USE_YA) {
    ym('reachGoal', 'BuyerPurchaseComplete');
  }
}
